import {CommonMessages} from '../common.messages';

export const PanelClientsEditAmlEstimatedWorthMessages = {
    UpdateQuestionnaireFailed: {
        key: 'UpdateQuestionnaireFailed',
        message: 'Error while communication with the server. Unable to update <<ref>> details.'
    },
    GetIndividualFailed: {
        key: 'GetIndividualFailed',
        message: 'Error while communication with the server. Unable to find individual client details.'
    },
    GetFinancialQuestionnaireInvalidData: {
        key: 'GetFinancialQuestionnaireInvalidData',
        message: 'Financial questionnaire data is corrupted.'
    },
    ...CommonMessages
};
